import React from 'react';
import { motion } from 'framer-motion';
import { imageVariants, textVariants, containerVariants } from '../../script/animationVariants';
import { useTranslation } from 'react-i18next';

// Örnek yearData: Her yıl için title ve description artık nesne olarak tanımlandı.
const yearData = [
  {
    images: [
      { src: '' },
    ],
    title: { tr: '1987', en: '1987' },
    description: {
      tr: 'İnşaat sektöründe büyük dönüşümlerin yaşandığı bir dönem. İşte tam da bu dönemde, güçlü bir vizyona sahip bir ekip, inşaat projelerinin vazgeçilmezi olacak iskele ve kalıp sistemlerini üretme hayaliyle yola çıktı. Denizli 2. Sanayi Sitesindeki küçük bir atölyede başlayan bu serüven, kısa sürede büyümenin ilk sinyallerini verdi.',
      en: 'During a period of great transformation in the construction sector. Right at this time, a team with a strong vision set out with the dream of producing scaffolding and formwork systems that would be indispensable for construction projects. This adventure, which began in a small workshop in Denizli 2nd Industrial Site, gave the first signals of growth in a short time.'
    }
  },
  {
    images: [
      { src: '' },
    ],
    title: { tr: '1988', en: '1988' },
    description: {
      tr: 'Yalnızca iskele üretimiyle sınırlı kalmayan bu ekip, 1988 yılında beton kalıpları imalatına başladı. Talebin artmasıyla birlikte, küçük atölye yetersiz hale geldi ve büyümek kaçınılmaz oldu. Bunun üzerine, geleceğe daha sağlam adımlarla yürüyebilmek için Denizli Organize Sanayi Bölgesinde 10.000 m²’lik bir arazi satın alındı.',
      en: 'This team, which was not limited to just scaffolding production, started manufacturing concrete formworks in 1988. With the increase in demand, the small workshop became insufficient and growth was inevitable. Thereupon, a 10,000 m² land was purchased in Denizli Organized Industrial Zone in order to walk with firmer steps into the future.'
    }
  },
  {
    images: [
      { src: '' },
    ],
    title: { tr: '1989', en: '1989' },
    description: {
      tr: 'Bu büyük hayali gerçeğe dönüştürecek fabrikanın 800 m²lik ilk etap temelleri atıldı.',
      en: 'The 800 m² first phase foundations of the factory that will make this big dream come true have been laid..'
    }
  },
  {
    images: [
      { src: '/images/hakkimizda/001.png' },
    ],
    title: { tr: '1990', en: '1990' },
    description: {
      tr: 'Fabrika inşaatı tamamlandı ve iskele ile kalıp üretimini daha büyük ölçekte yapmaya başlandı. Artık şirket, sektörde adını duyurmaya başlamıştı.',
      en: 'The factory construction was completed and scaffolding and formwork production began on a larger scale. The company was now making a name for itself in the industry.'
    }
  },
  {
    images: [
      { src: '' },
    ],
    title: { tr: '1994', en: '1994' },
    description: {
      tr: 'Her geçen yıl daha fazla projeye imza atan ekip, kendi makinelerini üretmeye başladı. 1994’te iki adet abkant makinesi, kendi bünyelerinde tasarlanıp üretildi. Bu dönemde sadece üretimi büyütmekle kalmadılar, aynı zamanda inovasyon ve teknolojiyi de işin içine kattılar.',
      en: 'The team, which undertook more projects each year, began to produce its own machines. In 1994, two bending machines were designed and produced in-house. During this period, they did not only expanded production, but also incorporated innovation and technology into the business.'
    }
  },
  {
    images: [
      { src: '/images/hakkimizda/002.png' },
    ],
    title: { tr: '1996', en: '1996' },
    description: {
      tr: '1996 yılı, işlerin giderek çeşitlendiği bir yıl oldu. Artık sadece iskele ve kalıp üretmekle yetinmeyen şirket, çelik konstrüksiyon imalatına da başladı. Üretim hızla artıyor, pazar genişliyor, ihtiyaçlar çoğalıyordu. 1997’de fabrika sahası genişletildi ve toplamda 3.200 m²’lik üretim alanına ulaşıldı.',
      en: '1996 was a year when the business was increasingly diversified. The company, no longer content with just producing scaffolding and formwork, also began manufacturing steel construction. Production was increasing rapidly, the market was expanding, and needs were increasing. In 1997, the factory area was expanded and a total production area of ​​3,200 m² was reached.'
    }
  },
  {
    images: [
      { src: '' },
    ],
    title: { tr: '1999', en: '1999' },
    description: {
      tr: 'Zaman içinde rekabet arttı, ancak Gökdelen İskele Kalıp AŞ hep bir adım önde olmayı başardı. 1999’da otomasyon makinaları ve CNC teknolojisine yatırım yaparak üretim hattını daha modern ve verimli hale getirdi.',
      en: 'Competition increased over time, but Gökdelen İskele Kalıp AŞ always managed to stay one step ahead. In 1999, it invested in automation machines and CNC technology, making its production line more modern and efficient.'
    }
  },
  {
    images: [
      { src: '' },
    ],
    title: { tr: '2004', en: '2004' },
    description: {
      tr: 'Perakende satışı da önemseyen Gökdelen İskele, şehir içinde 250 m² bir dükkan kiralayarak, hem üretimini hem de kaba inşaatta kullanılan sarf malzemelerin satışını yapmaya başladı.',
      en: 'Gökdelen İskele, which also gives importance to retail sales, rented a 250 m² shop in the city centre and opened a retail store where both production and consumables used in the construction are sold to its customers.'
    }
  },
  {
    images: [
      { src: '' },
    ],
    title: { tr: '2006', en: '2006' },
    description: {
      tr: 'Denizli inşaat sektörü ilk defa plywood ile tanıştırıldı. Gerek perakende mağazasında gerekse de toptan olarak fabrikada satışı yapılarak plywood piyasasında lider bir oyuncu oldu.',
      en: 'Denizli construction sector was introduced to plywood for the first time. Gökdelen İskele Kalıp became a leading player in the plywood market by selling it both in retail store and wholesale in factory.'
    }
  },
  {
    images: [
      { src: '/images/hakkimizda/003.png' },
    ],
    title: { tr: '2008', en: '2008' },
    description: {
      tr: 'Fabrika sahası büyütülerek kapalı üretim alanı 6.600 m²’ye çıkarıldı. Şirket, hem yurt içinde hem de yurt dışında önemli projelere imza atıyor, iskele ve kalıp sistemlerinde adından söz ettiriyordu.',
      en: 'The factory area was enlarged and the indoor production area was increased to 6,600 m². The company was undertaking important projects both at home and abroad and was making a name for itself in scaffolding and formwork systems.'
    }
  },
  {
    images: [
      { src: '/images/hakkimizda/004.png' },
    ],
    title: { tr: '2016', en: '2016' },
    description: {
      tr: 'Üretimde kaynaklı montajda hassasiyet ve verimliliği artırmak için 7 eksenli endüstriyel kaynak robot sistemleri devreye alındı.',
      en: '7-axis industrial welding robot systems were put into operation to increase precision and efficiency in welded assembly in production.'
    }
  },
  {
    images: [
      { src: '/images/hakkimizda/005.png' },
    ],
    title: { tr: '2018', en: '2018' },
    description: {
      tr: 'Denizli’nin en büyük fason elektrostatik toz boya tesisi açıldı, böylece üretim kapasitesi daha da genişletildi.',
      en: 'Denizlis largest  electrostatic powder coating facility was opened, thus further expanding production capacity.'
    }
  },

  {
    images: [
      { src: '/images/hakkimizda/006.png' },
    ],
    title: { tr: '2020-24', en: '2020-24' },
    description: {
      tr: 'Şirketin inovasyon odaklı büyümesi 2020’de de devam etti. 2020 yılında Bystronic 6 kW Fiber Lazer Kesim Makinesi makine parkuruna eklenirken, 2022’de Bystronic Expert Pro 150 ton abkant makinesi ile üretim kapasitesi artırıldı. 2023 yılında ikinci bir Bystronic 12 kW Fiber Lazer Kesim Makinesi ve 18 adet Siegmund Kaynak Masası devreye alındı. 2024 yılında ise 2 adet COBOT kaynak robotu üretime entegre edilerek otomasyon süreci daha da ileri taşındı.',
      en: 'The companys innovation-focused growth continued in 2020. In 2020, the Bystronic 6 kW Fiber Laser Cutting Machine was added to the machine park, while in 2022, production capacity was increased with the Bystronic Expert Pro 150-ton press brake machine. In 2023, a second Bystronic 12 kW Fiber Laser Cutting Machine and 18 Siegmund Welding Tables were taken into operation. In 2024, 2 COBOT welding robots were integrated into production, further advancing the automation process.'
    }
  },
  {
    images: [
      { src: '' },
    ],
    title: { tr: '2021', en: '2021' },
    description: {
      tr: 'Geleceğe daha sağlam bir yatırım yapmak amacıyla Makine İhtisas Organize Sanayi Bölgesinde 30.000 m²’lik bir arazi satın alındı ve "Arla Metal İşleme Merkezi" markası kuruldu. Bu, şirketin sadece Türkiyede değil, küresel çapta bir oyuncu olma yolundaki hedef için en önemli adımlarından biri oldu.',
      en: 'In order to make a more solid investment in the future, a 30,000 m² land was purchased in the Machine Specialization Organized Industrial Zone and the "Arla Metal Processing Center" brand was established. This was one of the most important steps for the companys goal of becoming a player not only in Türkiye but also on a global scale.'
    }
  },
  {
    images: [
      { src: '/images/hakkimizda/007.png' },
    ],
    title: { tr: '2023', en: '2023' },
    description: {
      tr: 'Perakende alanında mevcut mağazanın yetersiz kalması nedeni ile, yine şehir içinde 1.700 m² arsa üzerinde yeni perakende satış mağazası için temel atıldı.',
      en: 'Due to the inadequacy of the existing retail store, the foundation was laid for a new retail store on a 1,700 m² plot of land within the city.'
    }
  },
  {
    images: [
      { src: '/images/hakkimizda/008.png' },
    ],
    title: { tr: '2024', en: '2024' },
    description: {
      tr: 'Perakende satış mağazasının inşaatı tamamlandı ve toplamda 2.700 m² kapalı alanda hizmet vermeye başladı.',
      en: 'The construction of the retail store has been completed and has started to provide service in a total closed area of ​​2,700 m².'
    }
  },
  {
    images: [
      { src: '' },
    ],
    title: { tr: '∞', en: '∞' },
    description: {
      tr: 'Bugün, Gökdelen İskele Kalıp AŞ; sektörde güvenin, kalitenin ve inovasyonun simgesi haline gelmiş durumda. Küçük bir atölyede başlayan bu yolculuk, büyük bir endüstriyel güce dönüşerek devam ediyor. Ve bu hikâye, inşaat sektörünün gelişimiyle birlikte yazılmaya devam edecek…',
      en: 'Today, Gökdelen İskele Kalıp has become a symbol of trust, quality and innovation in the sector. This journey that started in a small workshop continues by turning into a major industrial power. And this story will continue to be written along with the development of the construction sector…'
    }
  }
];

const Section2 = () => {
  // useTranslation hook'u ile mevcut dil değerini alıyoruz
  const { i18n } = require('react-i18next').useTranslation();
  const currentLanguage = i18n.language;

  return (
    <motion.div 
      className="col-start-3 col-span-12 mb-52"
      // Eğer isterseniz containerVariants ekleyebilirsiniz
      // initial="hidden"
      // whileInView="visible"
      // variants={containerVariants}
    >
      {/* Üstteki bölüm başlığı: "Tarihçe" */}
      <motion.h2 className="text-45 font-light mb-20">
        {currentLanguage === 'tr' ? 'Tarihçe' : 'History'}
      </motion.h2>
      <motion.div className="grid grid-cols-6 gap-10 w-full">
        {yearData.map((item, index) => (
          <motion.div 
            key={index} 
            className="col-span-6 grid grid-cols-7"
            // variants={containerVariants}
          >
            {/* Resim Bölümü */}
            <motion.div 
              className="col-span-6 md:col-span-2 mb-5"
              variants={imageVariants} 
            >
              <div className="w-full">
                {item.images[0].src && (
                  <img 
                    src={item.images[0].src} 
                    className="w-full object-cover" 
                    alt={item.title[currentLanguage]}
                  />
                )}
              </div>
            </motion.div>
            {/* Metin Bölümü */}
            <motion.div 
              className="col-span-6 md:col-span-3 ml-0 md:ml-20"
              variants={textVariants}
            >
              <div className="h-full">
                <h2 className="flex flex-col text-45">
                  {item.title[currentLanguage]}
                </h2>
                <p className="text-20">
                  {item.description[currentLanguage]}
                </p>
              </div>
            </motion.div>
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default Section2;
